import { useConversions } from './useConversions';

export const useCurrentConversion = currentIndex => {
    const { conversions } = useConversions();
    return conversions?.[currentIndex];
};
